// @flow
import _ from 'lodash'

// TODO: this generalization isn't great because most of these 'general' getters are actually specific
// TODO: to a single type - with the exception of getItemById and getItemsForApp (fields & flows)
export default {
  getItemById: (state: any) => (id: string): ?Object => {
    return state.itemsInitialized ? _.cloneDeep(_.find(state.items, { id: id })) : []
  },
  // NOTE: Only used to get fields and flows for a given app
  getItemsForApp: (state: any) => (itemId: string): Array<Object> => {
    return state.itemsInitialized && itemId
      ? _.cloneDeep(_.filter(state.items, i => itemId && itemId === i.application))
      : []
  },
  // NOTE: Only used to get groups by user
  getItemsByUser: (state: any) => (userId: string): Array<Object> => {
    return state.itemsInitialized
      ? _.cloneDeep(_.filter(state.items, i => _.includes(i.user, userId)))
      : []
  },
  // NOTE: Only used to get groups by flow
  getItemsByFlow: (state: any) => (flowId: string): Array<Object> => {
    return state.itemsInitialized
      ? _.cloneDeep(_.filter(state.items, i => _.includes(i.flow, flowId)))
      : []
  },
  // NOTE: Only used to get flows by maintainer
  getItemsByMaintainer: (state: any) => (userId: string): Array<Object> => {
    return state.itemsInitialized
      ? _.cloneDeep(_.filter(state.items, i => i.maintainer === userId))
      : []
  },
  // NOTE: Only used to get users by name
  getByName: (state: any) => (name: string): Object => {
    return _.cloneDeep(_.filter(state.items, i => i.name === name))
  }
}
